import React from 'react';

import Image from 'next/image';

import styles from './Spinner.module.scss';

const Spinner = () => (
  <div id="Spinner" className={styles.spinnerFixed}>
    <Image src="/auth/v1/static/spinner.gif" unoptimized alt="Loading" width={100} height={100} />
  </div>
);

export default Spinner;
